import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromViewedReportIds from './viewed-report-ids.reducer';

export const selectViewedReportIdsState = createFeatureSelector<fromViewedReportIds.State>(
  fromViewedReportIds.viewedReportIdsFeatureKey
);

export const selectViewedReportIds = createSelector(selectViewedReportIdsState, (state) => state.viewedReportIds);
export const selectIsComplete = createSelector(selectViewedReportIdsState, (state) => state.isComplete);
